import SplashInfoPop from "./splash-info-popup";

export default SplashInfoPop;